import { render, staticRenderFns } from "./UpdateButton.vue?vue&type=template&id=1276a4a8&lang=pug"
import script from "./UpdateButton.vue?vue&type=script&lang=js"
export * from "./UpdateButton.vue?vue&type=script&lang=js"
import style0 from "./UpdateButton.vue?vue&type=style&index=0&id=1276a4a8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports